export default "__VITE_ASSET__af52cdef__"